// Parent product component
if (!customElements.get('component-product-reviews')) {
  customElements.define('component-product-reviews', class ProductReviews extends HTMLElement {
    constructor() {
      super();
      // Listen for custom event sent from PDP on color change
      document.addEventListener('update-pdp-product-reviews', this.renderSection);
    }
    async renderSection() {
      try {
        const sectionId = document.querySelector('component-product-reviews').dataset.sectionId;
        let section = await fetch(`${window.Shopify.routes.root}products/${event.detail.handle}?section_id=${sectionId}`);
        section = await section.text();
        if (section) {
          document.querySelector('.js-component-product-reviews').innerHTML = section;
          if (window.yotpoWidgetsContainer) {
            window.yotpoWidgetsContainer.initWidgets()
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
    disconnectedCallback() {
      document.removeEventListener('update-pdp-sections', this.renderSection, true);
    }
  });
}
